<template>

  <v-main class="content-page-bg">

    <v-container v-if="album" fluid>

      <!-- ALBUM SAMARY -->
      <v-row class="my-1">

        <!-- thumbnail -->
        <v-col :class="['d-flex child-flex', { 'mx-auto': isMobile }]" cols="8" md="3" xs="6">
          <v-card :class="[isMobile ? 'w-100' : 'w-100', 'pa-1 my-custom-card rounded']">
            <v-img :src="album.thumbnail.link" :alt="`دانلود آلبوم OST سریال ${album.fa_title} در کره فای`" aspect-ratio="1.0"
              class="rounded">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey-lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-card>
        </v-col>
        <!-- thumbnail -->

        <!-- more info in desktop -->
        <v-col v-if="!isMobile && album?.fa_description" class="d-flex align-end" cols="12" md="8" xs="12">

          <v-card class="w-75 text-white shadow-none" li :color="'#262626'" variant="elevated">

            <v-card-item>
              <div>

                <div>
                  خلاصه
                </div>

                <!-- <p :class="[isMobile ? 'text-xsm' : 'text-caption']"><v-icon class="mr-2" color="yellow"
                    icon="mdi-star"></v-icon>{{ album.metadata.data.details.score }}</p>
                <p :class="[isMobile ? 'text-xsm' : 'text-caption']"><v-icon class="mr-2" color="green"
                    icon="mdi-shape"></v-icon>{{ album.metadata.data.details.genres }}</p> -->

                <div class="album-detail"> {{ shortStr(album.fa_description) }}</div>

              </div>
            </v-card-item>

            <v-card-actions>

              <div class="text-center pa-1">

                <v-btn @click="albumInfoDialog = true" class="bg-more-btn">
                  اطلاعات بیشتر
                </v-btn>

                <v-dialog v-model="albumInfoDialog" scrollable width="60%" opacity="0.9">

                  <v-card theme="dark">

                    <v-card-title class="text-h5 w-100 text-white shadow-none">
                      <h1 :class="['d-inline-block', isMobile ? 'text-16' : 'text-h5']" style='max-width: 4em'>{{
                        album.metadata.data.main_title }}
                        <span class="text-subtitle-2 text-pink-lighten-3"></span>
                      </h1>
                    </v-card-title>

                    <v-card-text>
                      <!-- DETAILS -->
                      <v-row class="">
                        
                        <v-col cols="12" class="px-0">
                          <v-card class="w-100 text-white shadow-none" color="#262626">

                            <v-card-item>
                              <div>
                                <div class="mb-2">
                                  جزئیات
                                </div>

                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>نام فارسی:</b> {{
                                  album.fa_title }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>نام اصلی:</b> {{
                                  album.metadata.data.details.native_title }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>نام های دیگر:</b> {{
                                  album.metadata.data.details.known_as }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>ژانر:</b> {{
                                  album.metadata.data.details.genres
                                  }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>امتیاز:</b> {{
                                  album.metadata.data.details.score
                                  }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>کشور:</b> {{
                                  album.metadata.data.details.country }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>قسمت ها:</b> {{
                                  album.metadata.data.details.episodes }} </p>
                                <!-- <p :class="[ isMobile ? 'text-sm' : 'text-caption']" ><b>Genre:</b> {{ item.metadata.data.details.known_as }} </p> -->
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>زمان پخش:</b> {{
                                  album.metadata.data.details.aired_on }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>رتبه:</b> {{
                                  album.metadata.data.details.ranked
                                  }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>نویسنده:</b> {{
                                  album.metadata.data.details.screen_writer }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>کارگردان:</b> {{
                                  album.metadata.data.details.director }} </p>

                              </div>
                            </v-card-item>

                          </v-card>
                        </v-col>
                      </v-row>
                      <!-- DETAILS -->

                      <!-- MORE INFO -->
                      <v-row class="">

                        <v-col cols="12" class="px-0">

                          <v-card class="w-100 text-white shadow-none" color="#262626" variant="elevated">

                            <v-card-text>
                              <div>
                                <div class="mb-2">
                                  داستان
                                </div>
                                <div class="album-detail" v-html="formattedText()"></div>
                              </div>
                            </v-card-text>

                          </v-card>
                        </v-col>
                      </v-row>
                      <!-- MORE INFO -->
                    </v-card-text>



                    <v-divider></v-divider>


                    <template v-slot:actions>
                      <v-btn class="ms-auto" text="بستن" @click="albumInfoDialog = false"></v-btn>
                    </template>

                  </v-card>

                </v-dialog>
              </div>
            </v-card-actions>

          </v-card>

        </v-col>
        <!-- more info -->

        <!-- title & options -->
        <v-col class="child-flex align-end" cols="12" md="12" xs="12">
          <div class="align-center text-white">
            <!-- <span class="mr-2">Openion</span> -->
            <h1 :class="[{ 'mobile-title text-center px-1': isMobile }]">{{ albumName(album.title) }}</h1>
            <p :class="[{ 'mobile-title text-center': isMobile }]">
              <span class="mr-2">{{ album.fa_title }} •</span>
              <!-- <span v-else class="mr-2">By {{ album.artists?.[0]?.name }} •</span> -->
              <span class="mr-2">{{ album.year }}</span>
              <!-- <span class="mr-2">{{ album.tracks.length }} Songs</span> -->
            </p>

          </div>
        </v-col>
        <!-- title & options -->

        <!-- more info in mobile -->
        <v-col v-if="isMobile && album?.fa_description" class="d-flex child-flex px-4 mx-0" cols="12" md="7" xs="12">

          <v-card class="w-100 text-white shadow-none" :color="isMobile ? '#262626' : 'transparent'" variant="elevated">

            <v-card-item>

              <div>

                <div>
                  خلاصه
                </div>

                <div class="album-detail"> {{ shortStr(album.fa_description) }}</div>

              </div>
            </v-card-item>

            <v-card-actions>

              <div class="text-center pa-1">

                <v-btn @click="albumInfoDialog = true" class="bg-more-btn">
                  اطلاعات بیشتر
                </v-btn>

                <v-dialog v-model="albumInfoDialog" scrollable width="auto" opacity="0.9">

                  <v-card theme="dark">

                    <v-card-title class="text-h5 w-100 text-white shadow-none">
                      <h1 :class="['d-inline-block', isMobile ? 'text-16' : 'text-h5']" style='max-width: 4em'>{{
                        album.metadata.data.main_title }}
                        <span class="text-subtitle-2 text-pink-lighten-3"></span>
                      </h1>
                    </v-card-title>

                    <v-card-text>
                      <!-- DETAILS -->
                      <v-row class="">
                        <v-col cols="12" class="px-0">
                          <v-card class="w-100 text-white shadow-none" color="#262626">

                            <v-card-item>
                              <div>
                                <div class="mb-2">
                                  جزئیات
                                </div>

                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>نام اصلی:</b> {{
                                  album.metadata.data.details.native_title }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>نام های دیگر:</b> {{
                                  album.metadata.data.details.known_as }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>ژانر:</b> {{
                                  album.metadata.data.details.genres
                                }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>امتیاز:</b> {{
                                  album.metadata.data.details.score
                                }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>کشور:</b> {{
                                  album.metadata.data.details.country }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>قسمت ها:</b> {{
                                  album.metadata.data.details.episodes }} </p>
                                <!-- <p :class="[ isMobile ? 'text-sm' : 'text-caption']" ><b>Genre:</b> {{ item.metadata.data.details.known_as }} </p> -->
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>روز های پخش:</b> {{
                                  album.metadata.data.details.aired_on }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>رتبه:</b> {{
                                  album.metadata.data.details.ranked
                                }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>نویسنده:</b> {{
                                  album.metadata.data.details.screen_writer }} </p>
                                <p :class="[isMobile ? 'text-sm' : 'text-caption']"><b>کارگردان:</b> {{
                                  album.metadata.data.details.director }} </p>

                              </div>
                            </v-card-item>

                          </v-card>
                        </v-col>
                      </v-row>
                      <!-- DETAILS -->

                      <!-- MORE INFO -->
                      <v-row class="">

                        <v-col cols="12" class="px-0">

                          <v-card class="w-100 text-white shadow-none" color="#262626" variant="elevated">

                            <v-card-text>
                              <div>
                                <div class="mb-2">
                                  داستان
                                </div>
                                <div class="album-detail" v-html="formattedText()"></div>
                              </div>
                            </v-card-text>

                          </v-card>
                        </v-col>
                      </v-row>
                      <!-- MORE INFO -->
                    </v-card-text>



                    <v-divider></v-divider>


                    <template v-slot:actions>
                      <v-btn class="ms-auto" text="بستن" @click="albumInfoDialog = false"></v-btn>
                    </template>

                  </v-card>

                </v-dialog>
              </div>
            </v-card-actions>

          </v-card>

        </v-col>
        <!-- more info -->

        <v-col v-if="isMobile" class="mx-auto my-2" cols="8">
          <a :href="settings.telegram_chanel_url" target="_blank" class="w-100">
            <v-img :class="['w-100']" :src="settings.telegram_banner_url" alt="کانال تلگرام کره فای"></v-img>
          </a>
        </v-col>

      </v-row>
      <!-- ALBUM SAMARY -->


      <!-- TRACK LISTs -->
      <track-list v-bind="{ tracks: album.tracks, album: album, tracksParent: album }"></track-list>
      <!-- TRACK LISTs -->


      <!-- RELATEDS -->
      <div v-if="isMobile && relateds">

        <card-slide v-for="(related, index) in relateds" :key="index"
          v-bind="{ items: related.items, title: related.title, subTitle: related?.sub_title, type: related.type, shape: related.shape, aspectRatio: related.aspect_ratio, moreLink: related.has_more_link, cardBg: related.card_bg }"></card-slide>

      </div>

      <div v-else-if="!isMobile && relateds">

        <card-list v-for="(related, index) in relateds" :key="index"
          v-bind="{ items: related.items, title: related.title, subTitle: related?.sub_title, type: related.type, shape: related.shape, aspectRatio: related.aspect_ratio, moreLink: related.has_more_link, cardBg: related.card_bg }"></card-list>

      </div>
      <!-- RELATEDS -->

    </v-container>

  </v-main>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { getAlbum, getAlbumRelatd } from '@/api'
import { truncateString, replaceChars, albumtitle } from '@/helpers';
import store from '@/store';


export default {


  data() {
    return {
      albumHashId: null,
      album: null,
      relateds: null,
      albumInfoDialog: false
    }
  },

  components: {
    TrackList: defineAsyncComponent(() =>
      import('./includes/TrackList.vue')
    ),
    CardList: defineAsyncComponent(() =>
      import('./includes/CardList.vue')
    ),
    CardSlide: defineAsyncComponent(() =>
      import('./includes/CardSlide.vue')
    )
  },

  computed: {

    settings() {
      return this.$store.getters.settings;
    },

    isMobile() {
      return this.$store.getters.getIsMobile;
    },

    currentTracks() {
      return this.$store.getters.getCurrentTracks
    },

    currentTrack() {
      return this.$store.getters.getCurrentTrack
    },

    //track is playing or not
    isPlaying() {
      return this.$store.getters.getPlayerProps.isPlaying
    },

    //get current props of player
    playerProps() {
      return this.$store.getters.getPlayerProps
    },
  },

  methods: {

    albumName(name) {
      return albumtitle(name)
    },

    shortStr(val) {
      return truncateString(val)
    },

    setCurrentTrackAsync(track) {
      this.$store.dispatch('setCurrentTrackAsync', track);
    },

    setCurrentTracksAsync(tracks) {
      this.$store.dispatch('setCurrentTracksAsync', tracks);
    },

    setCurrentAlbumAsync(album) {
      this.$store.dispatch('setCurrentAlbumAsync', album);
    },


    parseUrlChars(val) {
      return replaceChars(val)
    },

    formattedText() {
      return this.album.fa_description.replace(/\n/g, "<br>");
    },

    async fetchAlbumData() {

      var albumResponse = await getAlbum(this.$route.params.slug)

      //check response
      if (albumResponse.ok == true) {

        this.album = albumResponse.data
        

        if (this.album) {

          store.commit('setCurrentComponent', this.album.page_title)

          if (!this.isPlaying) {
            document.title = this.album.page_title
          }

          this.albumHashId=this.album.hash_id

        }

        //set album info in state management
        this.setCurrentAlbumAsync(albumResponse.data);

        if (!this.currentTracks) {
          this.setCurrentTracksAsync(albumResponse.data.tracks);
          this.setCurrentTrackAsync(albumResponse.data.tracks[0])
        }

        var relatedResponse = await getAlbumRelatd(this.albumHashId)

        //check response
        if (relatedResponse.ok == true) {
          this.relateds = relatedResponse.data
        }
      }

    }
  },

  watch: {

    async $route(to, from) {

      if (to.name == from.name && to.params.slug !== from.params.slug) {

        window.scrollTo(0, 0)
        await this.fetchAlbumData();

      }
    },
  },


  async created() {
    await this.fetchAlbumData();
  }
};

</script>

<style></style>
